<br>


<!--div *ngIf="!showMailView" class="form-row btntop" style="margin-top: 10px;">
<div class="d-flex justify-content-start gap-2">
  <button class="btn border" (click)="search()" [disabled]="!form.valid">Sök</button>
  <button class="btn border" (click)="clear()">Rensa</button>
  <button class="btn border" (click)="expanded = !expanded;expandedlabel==='Stäng grupper'? expandedlabel='Öppna grupper' : expandedlabel='Stäng grupper'">{{expandedlabel}}</button>
  <p class="reportlabel">Rapport: Gottstående 1</p>
</div>
</div-->
<div
  *ngIf="!showMailView"
  class="ms-3 d-flex justify-content-start mt-2 mb-2"
>
  <div class="d-flex" style="gap: 1rem">
    <button class="btn border" (click)="search()">Sök</button>
    <button class="btn border" (click)="clear()">Rensa</button>
    <button
      class="btn border"
      (click)="
        expanded = !expanded;
        expandedlabel === 'Stäng grupper'
          ? (expandedlabel = 'Öppna grupper')
          : (expandedlabel = 'Stäng grupper')
      "
    >
      {{ expandedlabel }}
    </button>
    <div class="reportlabel">
      Rapport: Gottstående 1<i
        *ngIf="showSpinner"
        class="fa fa-spinner fa-spin"
        style="font-size: 22px; color: #920000; margin-left: 30px"
      ></i>
    </div>
  </div>
</div>


<div *ngIf="!showMailView" class="col-lg-12 me-4 ms-4">
  <form [formGroup]="form" (keydown.enter)="search()">

    <div class="row">

      <div class="col-xs-12 col-md-6 col-xl-4">
        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              Medlem
            </mat-panel-title>
            <mat-panel-description>

            </mat-panel-description>
          </mat-expansion-panel-header>

          <div>

            <mat-checkbox formControlName="onlyActiveMembers">Sök endast bland aktiva medlemmar</mat-checkbox>
          </div>

          <div class="row">



            <div class="form-group col-md-6">

              <label>
                Medlemsnummer
              </label>
              <!--div class="form-check-inline"-->
              <div class="row">
                <div class="col-md-5">

                  <input id="memberIdFrom" type="text" class="col-sm-6 col-md-11 col-lg-11 form-control form-control-sm cap" [ngClass]="form.get('memberIdFrom').errors?.requiredIfField2Filled ? 'border border-danger' : ''" formControlName="memberIdFrom">
                </div>
                --
                <div class="col-md-5">
                  <input id="memberIdTo" type="text" class="col-sm-11 col-md-11 col-lg-11 form-control form-control-sm cap" [ngClass]="form.get('memberIdTo').errors?.requiredIfField1Filled ? 'border border-danger' : ''" formControlName="memberIdTo">
                </div>
                <div class="col-md-6"></div>
                <!--/div-->
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-start gap-2">
            <div class="form-group">
              <label for="givenName">
                Förnamn
              </label>
              <input type="text" class="form-control form-control-sm cap" id="givenName" formControlName="givenName">
            </div>

            <div class="form-group">
              <label for="familyName">
                Efternamn
              </label>
              <input type="text" class="form-control form-control-sm cap" id="familyName" formControlName="familyName">
            </div>
          </div>

          <div class="d-flex justify-content-start gap-2">
            <div class="form-group">
              <label for="homeZipCode">
                Postnummer
              </label>
              <!--input type="text" class="form-control form-control-sm cap" id="homeZipCodes"
                formControlName="homeZipCodes" readonly-->
             
<div class="ui-inputgroup">
                    <input type="text" pInputText placeholder="Addera postnummer" formControlName="zipCode">
                    <button pButton type="button" class="ms-2" icon="fa fa-plus" [disabled]="!form.get('zipCode')?.value" style="color:black;" (click)="addZipCode()"></button>
                  </div>
            </div>
 <div *ngFor="let p of zipcodes" class="ms-3">
                <span> {{p}} <i class="fa fa-times" (click)="removeZipCode(p)"></i></span>
              </div>
            <!--div class="form-group">
              <label>&nbsp;</label>
              
                
                  <div class="ui-inputgroup">
                    <input type="text" pInputText placeholder="Addera postnummer" formControlName="zipCode">
                    <button pButton type="button" icon="fa fa-plus" style="color:black;" (click)="addZipCode()"></button>
                  </div>
                
              
            </div-->

          </div>
          <div class="d-flex justify-content-start gap-2">
            <div class="form-group">
              <label for="homeCity">
                Postort
              </label>
              <input type="text" class="form-control form-control-sm cap" id="homeCity" formControlName="homeCity">
            </div>

            <div class="form-group">
              <label for="homeCountry">Land</label>
              <select class="form-control form-control-sm" id="homeCountry" formControlName="homeCountry">
                <option></option>
                <option *ngFor="let c of countries" [value]="c.name">{{c.name}}</option>
              </select>
            </div>
          </div>




        </mat-expansion-panel>





        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              System datum
            </mat-panel-title>
            <mat-panel-description>

            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="form-group col-md-3">
              <label for="membershipCreatedFrom">
                Skapad
              </label>

              <!--p-calendar id="membershipCreatedFrom" formControlName="membershipCreatedFrom" appendTo="body"
                [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true"
                [inputStyle]="{'width':'90px'}" [yearNavigator]="true" yearRange="1920:2030" dateFormat="yy-mm-dd">
              </p-calendar-->
              <app-calendarnotrequired [form]="form" formName="membershipCreatedFrom"></app-calendarnotrequired>

            </div>
            <div class="form-group col-md-3">
              <label for="membershipCreatedTo">
                &nbsp;
              </label>

              <!--p-calendar id="membershipCreatedTo" formControlName="membershipCreatedTo" appendTo="body"
                [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true"
                [inputStyle]="{'width':'90px'}" [yearNavigator]="true" yearRange="1920:2030" dateFormat="yy-mm-dd">
              </p-calendar-->
              <app-calendarnotrequired [form]="form" formName="membershipCreatedTo"></app-calendarnotrequired>
            </div>

            <div class="form-group col-md-3">
              <label for="membershipChangedFrom">
                Ändrad
              </label>
              <!--p-calendar id="membershipChangedFrom" formControlName="membershipChangedFrom" appendTo="body"
                [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true"
                [inputStyle]="{'width':'90px'}" [yearNavigator]="true" yearRange="1920:2030" dateFormat="yy-mm-dd">
              </p-calendar-->
              <app-calendarnotrequired [form]="form" formName="membershipChangedFrom"></app-calendarnotrequired>
            </div>
            <div class="form-group col-md-3">
              <label for="membershipChangedTo">
                &nbsp;
              </label>
              <!--p-calendar id="membershipChangedTo" formControlName="membershipChangedTo" appendTo="body"
                [showWeek]="true" [locale]="se" [showButtonBar]="true" [monthNavigator]="true"
                [inputStyle]="{'width':'90px'}" [yearNavigator]="true" yearRange="1920:2030" dateFormat="yy-mm-dd">
              </p-calendar-->
              <app-calendarnotrequired [form]="form" formName="membershipChangedTo"></app-calendarnotrequired>
            </div>
          </div>
        </mat-expansion-panel>




        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              Medlemsår
            </mat-panel-title>
            <mat-panel-description>

            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-md-12">
              <table>
                <tr>
                  <td>


                    <p-select [options]="years" formControlName="memberYear" appendTo="body" [filter]="false" optionLabel="year" [style]="{'min-width':'110px', 'width':'110px'}">
                    </p-select>
                  </td>



                </tr>
              </table>
            </div>
            <br>
          </div>
        </mat-expansion-panel>


        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              SOFT prenumeration
            </mat-panel-title>
            <mat-panel-description>

            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-md-6">
              <p-selectButton [options]="soft" formControlName="isSoftSubscriber"></p-selectButton>
            </div>
          </div>
        </mat-expansion-panel>
        <br><br>
      </div>


      <div class="col-xs-12 col-md-6 col-xl-4">

        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              Medlemskap
            </mat-panel-title>
            <mat-panel-description>

            </mat-panel-description>
          </mat-expansion-panel-header>

Medlemskap i <span *ngIf="form.get('membershipSomeOrAll').errors?.nomembership" class="text-danger">(obligatoriskt)</span><br>
          <div class="d-flex justify-content-start align-items-center">
            <div>
              
              <p-selectButton [options]="someorall" formControlName="membershipSomeOrAll"></p-selectButton>
              </div>
              
              <div class="ms-2">
                <button *ngIf="form.get('membershipSomeOrAll').value" class="btn-small btn-primary"
                        (click)="displayMembershipInstitutions=true;">
                  <i class="fa fa-plus"></i>
                </button>
                <button *ngIf="form.get('membershipSomeOrAll').value" class="btn-small btn-primary"
                        title="Rensa valda institutioner" style="margin-left:4px;"
                        (click)="membershipselectedinstitutions=[]">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            


            <div class="ms-2">
              <table style="border:1px solid lightgrey;border-radius:3px;width:280px;">
                <tr *ngFor="let x of membershipselectedinstitutions">
                  <td>{{x.name}}</td>
                  <td align="right">
                    <i class="fa fa-times" (click)="removeMembershipSelectedInstitution(x.id)"
                       title="Ta bort vald institution"></i>
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <br>

          
              Medlemskapet påbörjades mellan<br>
     
              <div class="d-flex justify-content-start gap-2">

                <app-calendarnotrequired [form]="form" formName="membershipStartedFrom"></app-calendarnotrequired>&nbsp;

                <app-calendarnotrequired [form]="form" formName="membershipStartedTo"></app-calendarnotrequired>
                <button class="btn btn-primary" (click)="setDate('membershipStartedTo', 'membershipEndedFrom')"
                        style="margin-left:10px;">
                  Just nu
                </button>
              </div>

          
          <br>
         
              Medlemskapet avslutades mellan<br>
      
              <div class="d-flex justify-content-start gap-2">
                <app-calendarnotrequired [form]="form" formName="membershipEndedFrom"></app-calendarnotrequired>
              
                <app-calendarnotrequired [form]="form" formName="membershipEndedTo"></app-calendarnotrequired>
          </div>

     
        </mat-expansion-panel>


        <mat-expansion-panel class="accordionmargin" [expanded]="expanded">
          <mat-expansion-panel-header [expandedHeight]="'48px'">
            <mat-panel-title>
              Välj rapport
            </mat-panel-title>
            <mat-panel-description>

            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-md-12">
              <mat-radio-group aria-label="Typ" class="d-flex justify-content-start gap-3" formControlName="reportType" required>
                <mat-radio-button value="all">Alla betalningar per medlem</mat-radio-button>
                <mat-radio-button value="notfullypaid">Ej fullbetalda medlemmar</mat-radio-button>
              </mat-radio-group>
            </div>
            <br>
          </div>
        </mat-expansion-panel>

      </div>
      <div class="col-xs-12 col-md-6 col-xl-4">

      </div>

    </div>

  </form>


  <div *ngIf="gsr.length > 0">

    <div class="resultdiv">

      <p-menubar [model]="items">
        <div class="d-flex justify-content-end mr-2">
          <div class="justify-content-between align-items-center mt-1">
            Resultat: {{gsr?.length}}
            <span class="ms-2">Välj alla:
              <mat-checkbox #checkAll (change)="checkuncheckAll(checkAll);"></mat-checkbox>
            </span>
          </div>
        </div>
      </p-menubar>
      <table matSort class="table table-bordered" (matSortChange)="sortData($event)" matSortDisableClear=true>
        <tr>
          <th mat-sort-header="memberId">Medlemsnr</th>
          <th mat-sort-header="givenname">Förnamn</th>
          <th mat-sort-header="familyname">Efternamn</th>
          <th mat-sort-header="fullypaid">Fullbetald</th>
          <th mat-sort-header="primaryLodge">Primärloge</th>
          
          <th>Årsavgift</th>
          <th>Betalt totalt</th>
          <th mat-sort-header="currentLodge">Aktuell loge</th>
          <th>Epost</th>
        </tr>

        <tr *ngFor="let result of gsr">
          <td>
            <a [routerLink]="['/memberform/id/', result.memberId]">
              {{result.memberId}}
            </a>
          </td>
          <td>{{result.givenName}}</td>
          <td>{{result.familyName}}</td>
          <td *ngIf="result.yearBalance >= 0" class="text-center">
            <i class="fa fa-check" aria-hidden="true" style="color:green;"></i>
          </td>
          <td *ngIf="result.yearBalance < 0" class="text-center">
            <i class="fa fa-times" aria-hidden="true" style="color:red;"></i>
          </td>
          <td>{{result.primaryLodge}}</td>
          <!--<td>{{result.year}}</td>-->
          <td>{{result.feeAfterDiscount}}</td>
          <td>{{result.payments}}</td>
          <td>{{result.currentLodge}}</td>
         
          <td>
            <div class="d-flex justify-content-between">
              <!--mat-checkbox *ngIf="result.checkbox" #inputEl (change)="add(result, inputEl);" [checked]="result.checked"></mat-checkbox><i *ngIf="result.email1 && result.checkbox" class="fa fa-envelope-o mt-1" aria-hidden="true"></i-->
              <mat-checkbox *ngIf="result.checkbox" #inputEl (change)="add(result, inputEl);" [checked]="result.checked"></mat-checkbox><i *ngIf="result.checkbox" class="fa fa-envelope-o mt-1" aria-hidden="true"></i>
            </div>
          </td>
        </tr>
      </table>
    </div>

  </div>
</div>

  <div *ngIf="showMailView">
    <app-mail [memberlist]=selectedmembers (closeEmail)="closeEmail($event)"></app-mail>
  </div>
  <p-dialog header="Medlemskap i" [(visible)]="displayMembershipInstitutions" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="true" [resizable]="true" [maximizable]="true" appendTo="body">
    <app-institution-chooser [selectedinstitutions]="membershipselectedinstitutions" [form]="form" (institutionSelected)="setSelectedInstitutions($event, 'membership')"></app-institution-chooser>
  </p-dialog>

  <p-dialog header="Icke medlemskap i" [(visible)]="displayNoMembershipInstitutions" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="true" [resizable]="true" [maximizable]="true" appendTo="body">
    <app-institution-chooser [selectedinstitutions]="nomembershipselectedinstitutions" [form]="form" (institutionSelected)="setSelectedNoInstitutions($event, 'nomembership')"></app-institution-chooser>
  </p-dialog>
